import { render, staticRenderFns } from "./LiteratureDetail.vue?vue&type=template&id=9a0f8da2&scoped=true&"
import script from "./LiteratureDetail.vue?vue&type=script&lang=ts&"
export * from "./LiteratureDetail.vue?vue&type=script&lang=ts&"
import style0 from "./LiteratureDetail.vue?vue&type=style&index=0&id=9a0f8da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0f8da2",
  null
  
)

export default component.exports